module.exports = __webpack_public_path__ + "img/nav_icon_documents_dk.1621e419.svg";